import { createSlice } from '@reduxjs/toolkit'
import { AxiosError } from '@src/helpers/httpClient'

import { GLOBAL_STATE, LOGS_ASSESSMENT_STUDENT_LIST } from '../constants/actionTypes'
import * as actionCreators from './actions'
import { defaultState, initialState } from './initialState'

export const LOGS_ASSESSMENT = GLOBAL_STATE

export const { reducer: LogsAssessmentReducer } = createSlice({
  name: LOGS_ASSESSMENT,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(actionCreators.logsAssessmentStudentList.pending, state => {
        state[LOGS_ASSESSMENT_STUDENT_LIST].loading = true
      })
      .addCase(actionCreators.logsAssessmentStudentList.rejected, (state, action) => {
        state[LOGS_ASSESSMENT_STUDENT_LIST].loading = false
        state[LOGS_ASSESSMENT_STUDENT_LIST].error = action.payload as AxiosError
      })
      .addCase(actionCreators.logsAssessmentStudentList.fulfilled, (state, action) => {
        state[LOGS_ASSESSMENT_STUDENT_LIST].loading = false
        state[LOGS_ASSESSMENT_STUDENT_LIST].error = null
        state[LOGS_ASSESSMENT_STUDENT_LIST].data = action.payload
      })

    builder.addCase(actionCreators.logsAssessmentStudentListClear, state => {
      state[LOGS_ASSESSMENT_STUDENT_LIST] = defaultState()
    })
  },
})
